import theme from '../Theme/Theme';

const color = '#F5F5F5';
const styles = () => ({
  card: {
    color: '#000 !important',
    width: '100%',
    height: '100%',

    borderRadius: '12px',
  },
  list: {
    maxWidth: '310px',
    marginBottom: '44px',

    '& img': {
      height: '163px',
    },

    [theme.screenSize.mobile]: {
      '&': {
        maxWidth: '100%',
      },
    },
  },
  'list-mapOpen': {
    maxWidth: '100%',
    marginBottom: '24px',

    borderRadius: 0,

    transition: 'background 0.2s ease',

    '&:hover': {
      backgroundColor: '#f2f2f2',
    },

    '&:target': {
      border: `2px solid ${theme.colors.border}`,
    },
  },
  carousel: {
    maxWidth: '310px',

    '& img': {
      height: '163px',
    },
  },
  'map-full-screen': {
    background: theme.colors.contrastText,
    marginBottom: '32px',

    maxWidth: '343px',
    height: '102px',

    overflow: 'hidden',
  },
  'cardItem-map-full-screen': {
    background: theme.colors.contrastText,
    marginBottom: '32px',
    display: 'flex',

    '& img': {
      width: '102px',
      height: '102px',

      borderRadius: '12px 0 0 12px',

      marginRight: '12px',
    },
  },
  'map-popUp': {
    maxWidth: '310px',

    [theme.screenSize.mobile]: {
      '&': {
        maxWidth: '343px',
      },
    },
  },
  'cardItem-map-popUp': {
    maxWidth: '310px',

    '& img': {
      borderRadius: '12px 12px 0 0',
      height: '160px',
    },

    '& > div': {
      paddingInline: '16px',
      paddingBottom: '16px',
    },

    [theme.screenSize.mobile]: {
      '&': {
        display: 'flex',
        flexDirection: 'row',
      },

      '& img': {
        width: '102px',
        height: 'auto',
        objectFit: 'cover',
        objectPosition: 'center',

        borderRadius: '12px 0 0 12px',

        marginRight: '12px',
      },

      '& > div': {
        flex: 1,
        paddingInline: '0',
        paddingBottom: '16px',
      },
    },
  },
  'cardItem-list': {
    [theme.screenSize.mobile]: {
      '& img': {
        height: '160px',
      },
    },
  },
  'cardItem-list-mapOpen': {
    display: 'flex',
    flexDirection: 'row',

    paddingBottom: '25px',

    borderRadius: 0,
    borderBottom: `1px solid ${theme.colors.mediumGray}`,

    '& img': {
      maxWidth: '198px',
      height: '102px',
      width: '100%',
      marginRight: '25px',
    },

    [theme.screenSize.laptop]: {
      '&': {
        flexDirection: 'column',
      },
      '& img': {
        maxWidth: '448px',
        maxHeight: '203px',
        height: '100%',
        width: '100%',
        marginRight: 0,
      },
    },

    [theme.screenSize.mobile]: {
      '&': {
        borderBottom: 'none',
        padding: '0',
      },
      '& img': {
        maxWidth: '100%',

        marginRight: '0',
        objectFit: 'cover',
        objectPosition: 'center',
      },
    },
  },

  cardImage: {
    maxWidth: '100%',
  },

  imageSkeleton: {
    backgroundColor: theme.colors.lightText,
    transform: 'unset',
  },
  image: {
    borderRadius: 12,
    width: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  tags: {
    fontSize: theme.font.size.sm,
    lineHeight: theme.font.lineHeight.sm,
    gridArea: 'tags',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    margin: '-3px',
    paddingTop: '16px',
  },
  tag: {
    fontSize: theme.font.size.xs,
    lineHeight: theme.font.lineHeight.xs,
    color: theme.colors.lightText2,
    background: theme.colors.secondaryBackground,
    whiteSpace: 'nowrap',
    opacity: '0.8',
    padding: '3px 8px',
    borderRadius: 4,
    backgroundColor: color,
    margin: 3,
  },
  starIcon: {
    color: theme.colors.warning50,
    width: '18px',
    height: '18px',
  },
  favoriteIcon: {
    color: theme.colors.lightText2,
    width: '32px',
    height: '32px',
  },
  activeFavoriteIcon: {
    color: theme.colors.error,
    width: '32px',
    height: '32px',
  },
});

export default styles;
